import { SocialLinkType, type SocialLink } from "#gen/bundles/v1/contact_pb.js";

function isAbsolute(url: string): boolean {
	return url.startsWith("https://") || url.startsWith("http://");
}

function stripQueryStringAndHashFromPath(url: string): string {
	return url.split("?")[0].split("#")[0];
}

function getBaseURL(type: SocialLinkType): string[] {
	switch (type) {
		case SocialLinkType.LINKEDIN:
			return [`https://www.linkedin.com/in/`, `http://www.linkedin.com/in/`, `https://www.linkedin.com/company/`, `http://www.linkedin.com/company/`, `https://www.linkedin.com/posts/`, `http://www.linkedin.com/posts/`];
		case SocialLinkType.FACEBOOK:
			return [`https://www.facebook.com/`, `http://www.facebook.com/`];
		case SocialLinkType.SPOTIFY:
			return [`https://open.spotify.com/user/`, `http://open.spotify.com/user/`];
		case SocialLinkType.X:
			return [`https://x.com/`, `https://twitter.com/`, `http://x.com/`, `http://twitter.com/`];
		case SocialLinkType.INSTAGRAM:
			return [`https://www.instagram.com/`, `http://www.instagram.com/`];
		case SocialLinkType.YOUTUBE:
			return [`https://youtube.com/`, `http://youtube.com/`, `https://www.youtube.com/`, `http://www.youtube.com/`, `https://www.youtube.com/channel/`, `http://www.youtube.com/channel/`];
		case SocialLinkType.APPLE_MUSIC:
			return [`https://music.apple.com/profile/`, `http://music.apple.com/profile/`];
		case SocialLinkType.THREADS:
			return [`https://threads.com/`, `http://threads.com/`];
		case SocialLinkType.SNAPCHAT:
			return [`https://www.snapchat.com/add/`, `http://www.snapchat.com/add/`];
		case SocialLinkType.TIKTOK:
			return [`https://www.tiktok.com/@`, `http://www.tiktok.com/@`];
		case SocialLinkType.SOUNDCLOUD:
			return [`https://soundcloud.com/`, `http://soundcloud.com/`];
		case SocialLinkType.WHATSAPP:
			return [`https://wa.me/`, `http://wa.me/`];
		case SocialLinkType.TWITCH:
			return [`https://www.twitch.tv/`, `http://www.twitch.tv/`];
		case SocialLinkType.DISCORD:
			return [`https://discord.com/`, `http://discord.com/`];
		default:
			return [];
	}
}

export function getSocialName(type: SocialLinkType): string {
	switch (type) {
		case SocialLinkType.LINKEDIN:
			return "LinkedIn";
		case SocialLinkType.FACEBOOK:
			return "Facebook";
		case SocialLinkType.SPOTIFY:
			return "Spotify";
		case SocialLinkType.X:
			return "X";
		case SocialLinkType.INSTAGRAM:
			return "Instagram";
		case SocialLinkType.YOUTUBE:
			return "YouTube";
		case SocialLinkType.APPLE_MUSIC:
			return "Apple Music";
		case SocialLinkType.THREADS:
			return "Threads";
		case SocialLinkType.SNAPCHAT:
			return "Snapchat";
		case SocialLinkType.TIKTOK:
			return "TikTok";
		case SocialLinkType.SOUNDCLOUD:
			return "SoundCloud";
		case SocialLinkType.WHATSAPP:
			return "WhatsApp";
		case SocialLinkType.TWITCH:
			return "Twitch";
		case SocialLinkType.DISCORD:
			return "Discord";
		default:
			return "Unknown";
	}
}

export function getSocialLinkURL(type: SocialLinkType, id: string): string {
	if (isAbsolute(id)) {
		return id;
	}
	const baseURL = getBaseURL(type);
	if (!baseURL || baseURL.length === 0) {
		return "";
	}
	return `${baseURL[0]}${id}`;
}

export function validateSocialLinkId(link: SocialLink): boolean {
	let urlStr: string;
	if (!isAbsolute(link.id)) {
		urlStr = getSocialLinkURL(link.type, link.id);
	} else {
		urlStr = link.id;
	}
	const base = getBaseURL(link.type);
	return base.some(base => urlStr.startsWith(base));
}

export function parseIdFromLink(link: SocialLink): string {
	let urlStr: string;
	if (!isAbsolute(link.id)) {
		urlStr = getSocialLinkURL(link.type, link.id);
	} else {
		urlStr = link.id;
	}
	const baseURLs = getBaseURL(link.type);
	for (const base of baseURLs) {
		if (!urlStr.startsWith(base)) {
			continue;
		}
		let path = stripQueryStringAndHashFromPath(urlStr.substring(base.length));
		if (path.startsWith("@")) {
			path = path.substring(1);
		}
		if (path.endsWith("/")) {
			path = path.substring(0, path.length - 1);
		}
		const index = path.lastIndexOf("/");
		if (index === -1) {
			return path;
		}
		return path.substring(index + 1);
	}
	return link.id;
}
